import { Link } from "react-router-dom";
import PageBanner from "../components/PageBanner";
import { products } from "../mock/mock";
import { ArrowRight, Layers } from "lucide-react";

export default function Products() {
  return (
    <div>
      <PageBanner
        title="Our Products"
        subtitle="15 Product Ranges · 75+ Tape Variants for every industry"
        breadcrumbs={[{ label: "Products" }]}
      />

      <section className="py-14">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-3 mb-10">
            <div>
              <p className="text-[12px] uppercase tracking-[0.3em] text-[#c8102e] font-semibold mb-2">Browse Categories</p>
              <h2 className="font-heading font-extrabold text-3xl text-[#0d2240] section-title">All Adhesive Tapes</h2>
            </div>
            <p className="text-sm text-gray-500">Click on any category to view all sub-products & specifications.</p>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {products.map((p, i) => (
              <Link
                key={p.id}
                to={`/products/${p.slug}`}
                className="card-lift group bg-white rounded-xl overflow-hidden border border-gray-100"
              >
                <div className="relative h-56 overflow-hidden bg-[#f7f7f9]">
                  <img src={p.image} alt={p.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                  <div className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-white/95 text-[#c8102e] text-[10.5px] font-bold tracking-widest">
                    {String(i + 1).padStart(2, "0")} / 15
                  </div>
                  <div className="absolute bottom-3 right-3 inline-flex items-center gap-1 px-2 py-1 rounded-full bg-[#0d2240]/85 text-white text-[10.5px] font-semibold">
                    <Layers size={11} /> {p.subProducts.length} variants
                  </div>
                </div>
                <div className="p-5">
                  <h3 className="font-heading font-semibold text-[#0d2240] text-lg group-hover:text-[#c8102e] transition-colors">
                    {p.name}
                  </h3>
                  <p className="text-sm text-gray-600 mt-1 line-clamp-2 min-h-[40px]">{p.short}</p>
                  <div className="mt-4 flex items-center justify-between">
                    <span className="inline-flex items-center gap-1 text-[#c8102e] text-sm font-semibold">
                      Explore <ArrowRight size={14} />
                    </span>
                    <span className="text-[11px] text-gray-400 uppercase tracking-widest">View Details</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
